// extracted by mini-css-extract-plugin
export default {"container":"n0-z","modal":"o0-z","dimensions":"p0-z","brandName":"q0-z","productName":"r0-z","recipientEmail":"s0-z","recommendedFit":"t0-z","hiddenField":"u0-z"};